<script lang="ts" setup>
</script>

<template>
  <div>
    <div class="pt-140 text-70 text-#0A0B5C font-bold font-normal">
      <h2 class="flex">
        开源
        <div class="bg-[linear-gradient(90deg,#0049E7_0%,#53DBFF_100%)] bg-clip-text text-transparent">法律</div>
        社区
      </h2>
      <h2>欢迎您加入</h2>
      <h2>FOSS LEGAL</h2>
    </div>

    <p class="mt-13 w-560 text-18 text-#263238 font-normal leading-normal">开源法律社区由开放原子开源基金会打造，助力广大开源开发者、开源企业管理者及法律从业者系统了解开源合规风险，营造互动交流和资源共享的空间。</p>

    <div class="mt-24 flex-y-center gap-32">
      <a href="https://doc.weixin.qq.com/smartsheet/form/1_wpSB7CEAAAqB6Wk26co7OQptolH1-BsA_36c316" target="_blank">
        <button class="h-44 w-128 rounded-160 bg-#1180FF text-16 text-#E9FAFF">加入社区</button>
      </a>
      <a href="https://doc.weixin.qq.com/smartsheet/form/1_wpSB7CEAAAqB6Wk26co7OQptolH1-BsA_86d92b" target="_blank">
        <div class="flex-y-center text-16 text-#0A0B5C leading-120%">社区问题收集 <div class="i-icons:arrow-right-1 ml-8 size-16"></div> </div>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
